import { createContext, useContext, useState, useEffect, useMemo } from "react";

const ProgrammeContext = createContext(null);

// Static fallback so the accent is correct before /api/programmes resolves
const DEFAULTS = {
  CI: { code: "CI", name: "China Airlines", home_carrier_iata: "CI", accent_hex: "#E8501A", cabins: ["economy", "premium_economy", "business"], base: "" },
  PX: { code: "PX", name: "Air Niugini", home_carrier_iata: "PX", accent_hex: "#C8102E", cabins: ["economy", "business"], service_start_date: "2026-11-17", base: "/px" },
};

function hexToRgb(hex) {
  const h = hex.replace("#", "");
  return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16)).join(" ");
}

export function ProgrammeProvider({ children }) {
  const [code, setCode] = useState(() => localStorage.getItem("fare-programme") || "CI");
  const [programmes, setProgrammes] = useState(DEFAULTS);

  const programme = programmes[code] || DEFAULTS[code] || DEFAULTS.CI;

  // Accent token is the ONLY visual difference between programmes (ci-orange → --accent-rgb)
  useEffect(() => {
    document.documentElement.style.setProperty("--accent-rgb", hexToRgb(programme.accent_hex || "#E8501A"));
    document.documentElement.style.setProperty("--accent-hex", programme.accent_hex || "#E8501A");
    localStorage.setItem("fare-programme", code);
  }, [code, programme.accent_hex]);

  const value = useMemo(() => ({
    code, setCode, programme, programmes,
    isPX: code === "PX",
    setProgrammesFromApi: (list) => setProgrammes((prev) => {
      const next = { ...prev };
      (list || []).forEach((p) => { next[p.code] = { ...(prev[p.code] || {}), ...p, base: p.code === "CI" ? "" : `/${p.code.toLowerCase()}` }; });
      return next;
    }),
  }), [code, programme, programmes]);

  return <ProgrammeContext.Provider value={value}>{children}</ProgrammeContext.Provider>;
}

export const useProgramme = () => useContext(ProgrammeContext);
